import { render, staticRenderFns } from "./validate-account-dialog.vue?vue&type=template&id=e9b2c1d8&"
import script from "./validate-account-dialog.vue?vue&type=script&lang=js&"
export * from "./validate-account-dialog.vue?vue&type=script&lang=js&"
import style0 from "./validate-account-dialog.vue?vue&type=style&index=0&id=e9b2c1d8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports